export const normalizeSelectedPort = (formData, fallback = 'Otro puerto') => {
  const selected = formData?.d4_q8;
  const other = formData?.d4_q8_other?.toString().trim();

  if (!selected) return fallback;
  if (selected === 'Otros') return other || 'Otro puerto';
  return selected;
};

export const formatDateSafe = (value, fallback = 'Sin definir', options = { day: 'numeric', month: 'short', year: 'numeric' }) => {
  if (!value) return fallback;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return fallback;
  return date.toLocaleDateString('es-EC', options);
};
